import { useQuery } from "@tanstack/react-query";
import type { UseQueryOptions } from "@tanstack/react-query";

import type { GetPresignedUrlForGetPayload, GetPresignedUrlForGetResponse } from "@/core/types";

import { getPresignedUrl } from "../queryFunctions/getPresignedUrl";
import { presignedUrlKeys } from "../keyFactory";

export function useGetPresignedUrl({
  options,
  payload,
}: {
  options?: Omit<UseQueryOptions<GetPresignedUrlForGetResponse>, "queryKey" | "queryFn">;
  payload: Omit<GetPresignedUrlForGetPayload, "method" | "content_type">;
}) {
  return useQuery({
    queryFn: () => getPresignedUrl(payload),
    queryKey: presignedUrlKeys.get(payload),
    ...options,
  });
}
